import React, { Component } from 'react'
import { Layout, Modal, Form, Button, Select, Input, Row, Col, Radio } from 'antd'
import { graphql, withApollo, Query } from 'react-apollo'
import { withRouter } from 'react-router'
import _get from 'lodash/get'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import _includes from 'lodash/includes'
import clientAuth from '../utils/client-auth'
import eventQuery from '~/graphql/queries/event.gql'
import registrationQuery from '~/graphql/queries/registration.gql'
import updateRegistrationMutation from '~/graphql/mutations/updateRegistration.gql'
// import statesQuery from '~/graphql/queries/states.gql'
// import countries from '~/data/countries'
import '~/styles/RegistrationEdit.css'
import Loading from '~/components/Loading'
// import Error404 from '~/components/Error/404'
import adminQuery from '~/graphql/queries/adminUser.gql'
import InputThaiAddress from '~/components/InputThaiAddress'
// import '~/styles/App.css'



const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
}
@Form.create()
@withRouter
@withApollo
@graphql(registrationQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { id },
    fetchPolicy: 'network-only'
  })
})
@graphql(eventQuery, {
  options: ({ match: { params: { eventId } } }) => ({
    variables: { _id: eventId },
    fetchPolicy: 'network-only'
  }),
  props: ({ data }) => ({
    event: data.event,
    eventLoading: data.loading
  })
})
@graphql(updateRegistrationMutation, {
  name: 'updateRegistration'
})
@graphql(adminQuery, {
  options: () => ({
    variables: { _id: clientAuth.login()._id },
    fetchPolicy: 'network-only'
  }),
  props: ({ data: { loading, adminUser } }) => ({
    adminLoading: loading,
    admin: adminUser
  })
})
class RegistrationEdit extends Component {
  submitting = false
  state = {
    deliveryOptionCheck : false
  }
  onClose = e => {
    const { registration, history } = this.props
    history.push(`/reg/${registration._id}/preview`)
  }
  alertError = (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        Modal.error({
          title: 'Error',
          content: error.message
        })
      })
    } else {
      Modal.error({
        title: 'Error',
        content: err.message
      })
    }
  }
  handleSubmit = e => {
    e.preventDefault()
    const { form, updateRegistration, event, data: {registration}, history } = this.props
    form.validateFieldsAndScroll({ force: true }, (err, record) => {
      if (err) return console.error(err)
      if (!this.submitting) {
        this.submitting = false
        const { _id, ...rest } = record
        updateRegistration({
          variables: {
            _id,
            record: rest
          }
        }).then(res => {
          history.push(`/events/${event._id}/registrations/${registration._id}`)
        }).catch(e => {
          console.error({e})
          this.alertError(e)
          this.submitting = false
        })
      }
    })
  }
  onChange = (targetName) => (targetValue) => {
    const {
      setFieldsValue,
    } = this.props.form
    console.log(targetName, targetValue);
    setFieldsValue({ [targetName]: targetValue })
  }
  onChangeDelivery = (value) => {
    console.log(value, 'value');
    //find
    const deliveryOptions = _get(this.props.data.registration, 'registrationType.deliveryOptions', []) || []
    const deliveryOption = deliveryOptions.find(o => o._id === value)
    if(deliveryOption.enabled){
      this.setState({
        deliveryOptionCheck : true,
      })
    } else {
      this.setState({
        deliveryOptionCheck : false,
      })
    }
  }
  onSelect = (addresses) => {
    const {
      setFieldsValue,
    } = this.props.form
    const { subdistrict, district, province, zipcode } = addresses
    setFieldsValue({
      'deliveryAddress.locality': subdistrict,
      'deliveryAddress.city': district,
      'deliveryAddress.province': province,
      'deliveryAddress.postalCode': zipcode })
    // or this.setState({ ...addresses })
  }
  render () {
    const {
      form,
      data,
      admin,
      // updateRegistrationMutation
      t
    } = this.props
    console.log(admin, 'admin');
    const {roles} = clientAuth.login()
    const {
      getFieldDecorator,
      getFieldValue
      // validateFieldsAndScroll
    } = form
    const locale = 'th'
    const requiredFieldMessage = 'This field is required'
    const event = _get(this.props, 'event')
    const registrationTypes = _get(event, 'registrationTypes', [])

    if (data.loading) return <Loading />
    const { registration, adminUser } = data
    // console.log({ data })
    const eventId = _get(this.props, 'match.params.eventId')

    getFieldDecorator('_id', {
      initialValue: _get(registration, '_id')
    })

    let statuses = ['draft', 'submitted', 'accepted', 'rejected', 'cancelled']
    if(
      _get(admin, 'organizerId') === '5a56aad18ec5f75108ac001d' ||
      _get(admin, 'organizerId') === '619734b40350e5e5ef4b0bee' ||
      _get(admin, 'organizerId') === '6421724ce103debe12bc38a2' ||
      _includes(_get(admin, 'roles'), 'admin')
      ) {
      statuses = ['draft', 'submitted', 'accepted', 'rejected', 'cancelled']
    } else {
      statuses = ['draft', 'submitted', 'cancelled']
    }

    const deliveryOptions = _get(registration, 'registrationType.deliveryOptions', []) || []
    const deliveryOption = deliveryOptions.find(o => o._id === registration.deliveryOptionId)
    const country = getFieldValue('deliveryAddress.country') || _get(data, 'deliveryAddress.country') || 'Thailand'
    const isThailand = country === 'Thailand'
    const locality = getFieldValue('deliveryAddress.locality') || _get(data, 'deliveryAddress.locality')
    const city = getFieldValue('deliveryAddress.city') || _get(data, 'deliveryAddress.city')
    const province = getFieldValue('deliveryAddress.province') || _get(data, 'deliveryAddress.province')
    const postalCode = getFieldValue('deliveryAddress.postalCode') || _get(data, 'deliveryAddress.postalCode')
    // const editDisabled = ['60e3fdaa1c327b52f5846959', '62d50043ec8d4b20cdcf9abf','62de4967bde39e9bf5acf796','62df9065293bc1688d374b22','62dfa7c1293bc1688d71b1e9','62e0fb45a6a9844612f7f3e5','62e1693ba6a984461203411d','62e21a5ea6a9844612a73d74','62e21e6ba6a9844612ac377e','62e21e77a6a9844612ac3ed7','62e21e9fa6a9844612aca19a','62e223fda6a9844612b41f6b','62e224b4a6a9844612b51097','62e22870a6a9844612bc4503','62e22dc1a6a9844612c2d793','62e2325fa6a9844612c8be2a','62e23c60a6a9844612d5d9d5','62e23f1ea6a9844612d93a7e','62e24299a6a9844612de3639','62e250c4a6a9844612f10219','62e25472a6a9844612f64c6e','62e74a94a6a9844612d538a6','62e78517a6a984461261371d','62e8be8876aa3cb36ac39baa','62e923f576aa3cb36a0c280f','62e95ecd76aa3cb36aac8792','62e9b89676aa3cb36ad3807a','62e9d25876aa3cb36a031fdd','62e9d78076aa3cb36a104e1a','62ea204b76aa3cb36adb12af','62ea912a76aa3cb36a20a9cf','62eaaadc76aa3cb36a64b6cf','62eb16a576aa3cb36abb0086','62eb7f4f76aa3cb36a5dbfe4','62eb8f1f76aa3cb36a99f7a5','62eb98a976aa3cb36abb2c35','62eb9cb076aa3cb36ad25639','62eba24676aa3cb36af12786','62ebbb7976aa3cb36a8735bc','62ec64a076aa3cb36a9d929b','62ecc0d676aa3cb36a85e2fb','62eccd5276aa3cb36ac75d83','62ecd70f76aa3cb36aff34c1','62ece26676aa3cb36a4497a0','62ece7df76aa3cb36a61fc2c','62ef2a0376aa3cb36a86c811','62ef3dd576aa3cb36aed26c4','62efcea676aa3cb36a899100','62f1205076aa3cb36a506f9c','62f255291090e021d1e2637f','62f27fb21090e021d17e215c','62f3104d1090e021d1519cd7','62f322b31090e021d1aaeb4c','62f3276e1090e021d1c032fe','62f33bc21090e021d1f5dd47','62f372b31090e021d1f129c9','62f39afa1090e021d134aa4e','62f3b1261090e021d1750fff','62f3bd501090e021d1b077a3','62f3c95c1090e021d1ecc936','62f3cdb91090e021d1055bc7','62f3d1a31090e021d11aa078','62f3d7a91090e021d135771a','62f3e7a51090e021d175b920','62f447e61090e021d188260d','62f4a0251090e021d135f394','62f513041090e021d16416ca','62f51cb41090e021d196e3bc','62f5ade01090e021d1bd641f','62f5b6a81090e021d1ed1ac4','62f62f9c1090e021d1032165','62f646261090e021d168dc96','62f688e91090e021d18ec09d','62f693261090e021d1b51f46','62f703ea1090e021d13dcd01','62f7c5f31090e021d17257fc','62f83d811090e021d1ec2530','62f895d71090e021d1646bbe','62f89e8d1090e021d18a3b60']
    const editDisabled = ['62d50043ec8d4b20cdcf9abf','62de4967bde39e9bf5acf796','62df9065293bc1688d374b22','62dfa7c1293bc1688d71b1e9','62e0fb45a6a9844612f7f3e5','62e1693ba6a984461203411d','62e21a5ea6a9844612a73d74','62e21e6ba6a9844612ac377e','62e21e77a6a9844612ac3ed7','62e21e9fa6a9844612aca19a','62e223fda6a9844612b41f6b','62e224b4a6a9844612b51097','62e22870a6a9844612bc4503','62e22dc1a6a9844612c2d793','62e2325fa6a9844612c8be2a','62e23c60a6a9844612d5d9d5','62e23f1ea6a9844612d93a7e','62e24299a6a9844612de3639','62e250c4a6a9844612f10219','62e25472a6a9844612f64c6e','62e74a94a6a9844612d538a6','62e78517a6a984461261371d','62e8be8876aa3cb36ac39baa','62e923f576aa3cb36a0c280f','62e95ecd76aa3cb36aac8792','62e9b89676aa3cb36ad3807a','62e9d25876aa3cb36a031fdd','62e9d78076aa3cb36a104e1a','62ea204b76aa3cb36adb12af','62ea912a76aa3cb36a20a9cf','62eaaadc76aa3cb36a64b6cf','62eb16a576aa3cb36abb0086','62eb7f4f76aa3cb36a5dbfe4','62eb8f1f76aa3cb36a99f7a5','62eb98a976aa3cb36abb2c35','62eb9cb076aa3cb36ad25639','62eba24676aa3cb36af12786','62ebbb7976aa3cb36a8735bc','62ec64a076aa3cb36a9d929b','62ecc0d676aa3cb36a85e2fb','62eccd5276aa3cb36ac75d83','62ecd70f76aa3cb36aff34c1','62ece26676aa3cb36a4497a0','62ece7df76aa3cb36a61fc2c','62ef2a0376aa3cb36a86c811','62ef3dd576aa3cb36aed26c4','62efcea676aa3cb36a899100','62f1205076aa3cb36a506f9c','62f255291090e021d1e2637f','62f27fb21090e021d17e215c','62f3104d1090e021d1519cd7','62f322b31090e021d1aaeb4c','62f3276e1090e021d1c032fe','62f33bc21090e021d1f5dd47','62f372b31090e021d1f129c9','62f39afa1090e021d134aa4e','62f3b1261090e021d1750fff','62f3bd501090e021d1b077a3','62f3c95c1090e021d1ecc936','62f3cdb91090e021d1055bc7','62f3d1a31090e021d11aa078','62f3d7a91090e021d135771a','62f3e7a51090e021d175b920','62f447e61090e021d188260d','62f4a0251090e021d135f394','62f513041090e021d16416ca','62f51cb41090e021d196e3bc','62f5ade01090e021d1bd641f','62f5b6a81090e021d1ed1ac4','62f62f9c1090e021d1032165','62f646261090e021d168dc96','62f688e91090e021d18ec09d','62f693261090e021d1b51f46','62f703ea1090e021d13dcd01','62f7c5f31090e021d17257fc','62f83d811090e021d1ec2530','62f895d71090e021d1646bbe','62f89e8d1090e021d18a3b60']
      .includes(`${_get(registration, 'eventId')}`)
    if(editDisabled) {
      return <>
        <h1 style={{textAlign: 'center', marginTop: '30px'}}>
          ปิดการแก้ไขข้อมูล
        </h1>
      </>
    }
    return (
      <Layout>
        <Layout.Content className="content form-content">
          <Form onSubmit={this.handleSubmit} /* style={{backgroundColor: '#ffffff'}} */ >
            <Row>
              <Col sm={{ span: 24 }}>
                <Input.Group key='event' className="input-group">
                  <Form.Item label={t("registration.eventName")} {...formItemLayout}>
                    {registration.event.name.th} <br/>
                    ({registration.event.name.en})
                  </Form.Item>
                </Input.Group>
                <Input.Group key={`registration`}>
                  {_includes(roles, 'admin') || _includes(admin.abilities, 'registrationType') ? <Form.Item label={t("registration.registrationType")} {...formItemLayout}>
                    {getFieldDecorator(`registrationTypeId`, {
                      initialValue: _get(registration, 'registrationTypeId')
                    })(
                      <Select className="select-type" >
                        {registrationTypes.map(regType =>
                          <Select.Option value={regType._id} key={regType._id}>{regType.name.en}</Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item> : <Form.Item label={t("registration.registrationType")} {...formItemLayout}>
                    {getFieldDecorator(`registrationTypeId`, {
                      initialValue: _get(registration, 'registrationTypeId')
                    })(
                      <Select disabled className="select-type" >
                        {registrationTypes.map(regType =>
                          <Select.Option value={regType._id} key={regType._id}>{regType.name.en}</Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>}
                  <Form.Item label={t("registration.status")} {...formItemLayout}>
                    {getFieldDecorator(`status`, {
                      initialValue: _get(registration, 'status'),
                      rules: [{ required: true, message: 'กรุณาเลือกสถานะ' }]
                    })(
                      // <Input key={`status`} />
                      <Radio.Group
                      disabled={
                        !_includes(_get(admin, 'roles'), 'admin') &&
                        admin.email !== 'khunmam@thai.run' &&
                        `${_get(admin, 'organizerId')}` !== '6421724ce103debe12bc38a2' && // maybank indo
                        `${_get(admin, 'organizerId')}` !== '628ddc09105c5c5e1b091605' && //PANDORA HA PA BURN
                        // `${_get(admin, 'organizerId')}` !== '642172fd625d76661881b070' && //info@maybank
                        !_includes(admin.abilities, 'registrationType')
                      }
                      >
                        {statuses.map(status => <Radio key={status} value={status}>{status}</Radio>)}
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Input.Group>
                {deliveryOptions.length > 0 && <Form.Item label={t("events.edit.application.delivery")} {...formItemLayout}>
                  {getFieldDecorator(`deliveryOptionId`, {
                    initialValue: _get(registration, 'deliveryOptionId')
                  })(
                    <Select style={{ width: 213 }}
                      placeholder="กรุณาเลือกตัวเลือกการจัดส่ง"
                      defaultValue=""
                      value={this._id}
                      onChange={this.onChangeDelivery}
                      disabled={!_includes(_get(admin, 'roles'), 'admin') && !_includes(admin.abilities, 'registrationEditAble')}
                    >
                      {deliveryOptions.map(d =>
                        <Select.Option value={d._id} key={d._id}>{d.name.th}</Select.Option>
                      )}
                    </Select>
                  )}
                </Form.Item>}
                {(deliveryOption && deliveryOption.enabled) || this.state.deliveryOptionCheck ? <Input.Group key={`deliveryAddress`}>
                  {
                    getFieldDecorator(`deliveryAddress._id`, {
                      initialValue: _get(registration, '_id')
                    })
                  }
                  {/* <Form.Item
                    label={{ en: 'Address number and street', th: 'บ้านเลขที่ และ ถนน' }[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.street`, {
                      initialValue: _get(registration, 'deliveryAddress.street'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(
                      <Input.TextArea rows={2}/>
                    )}
                  </Form.Item> */}
                  <Form.Item
                    label={{ en: 'Street', th: 'บ้านเลขที่'}[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.street`, {
                      initialValue: _get(registration, 'deliveryAddress.street'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(<Input key={`street`} />)}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Village', th: 'หมู่'}[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.village`, {
                      initialValue: _get(registration, 'deliveryAddress.village'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(<Input key={`village`} />)}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Building', th: 'หมู่บ้าน/อาคาร/ชั้น'}[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.building`, {
                      initialValue: _get(registration, 'deliveryAddress.building'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(<Input key={`building`} />)}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Soi', th: 'ซอย'}[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.soi`, {
                      initialValue: _get(registration, 'deliveryAddress.soi'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(<Input key={`soi`} />)}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Road', th: 'ถนน'}[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.road`, {
                      initialValue: _get(registration, 'deliveryAddress.road'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(<Input key={`road`} />)}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Country', th: 'ประเทศ' }[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.country`, {
                      initialValue: _get(registration, 'deliveryAddress.country') || 'Thailand',
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .startsWith(input.toLowerCase())}
                        style={{ width: 213 }}
                      >
                        {['Thailand'].map(country =>
                        // {countries.map(country =>
                          <Select.Option
                            key={country}
                            value={country}
                          >
                            {country}
                          </Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item
                    label={{ en: 'Locality', th: 'ตำบล/แขวง' }[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.locality`, {
                      initialValue: _get(registration, 'deliveryAddress.locality'),
                      rules: [{ required: true,
                        pattern: /^[ก-๙-]{2,30}$/,
                        message: "กรอกเป็นภาษาไทยให้ถูกต้อง" }]
                    })(
                      isThailand ?
                        <InputThaiAddress
                          field={"subdistrict"}
                          value={locality}
                          onChange={this.onChange("locality")}
                          onSelect={this.onSelect}
                        /> :
                        <Input />
                    )}
                  </Form.Item>

                  <Form.Item
                    label={{ en: 'City', th: 'อำเภอ/เขต' }[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.city`, {
                      initialValue: _get(registration, 'deliveryAddress.city'),
                      rules: [{ required: true,
                        pattern: /^[ก-๙-]{2,30}$/,
                        message: "กรอกเป็นภาษาไทยให้ถูกต้อง" }]
                    })(
                      isThailand ?
                        <InputThaiAddress
                          field={"district"}
                          value={city}
                          onChange={this.onChange("city")}
                          onSelect={this.onSelect}
                        />  :
                        <Input />
                    )}
                  </Form.Item>
                  
                  <Form.Item
                      label={{ en: 'Province', zh: 'Province', th: 'จังหวัด' }[locale]}
                      {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.province`, {
                      initialValue: _get(registration, 'deliveryAddress.province'),
                      rules: [{ required: true,
                        pattern: /^[ก-๙-]{2,30}$/,
                      message: "กรอกเป็นภาษาไทยให้ถูกต้อง" }]
                    })(
                      isThailand ?
                        <InputThaiAddress
                          field={"province"}
                          value={province}
                          onChange={this.onChange("province")}
                          onSelect={this.onSelect}
                        /> :
                        <Input />
                    )}
                  </Form.Item>
                  {/* <Query query={statesQuery} variables={{ countryName: 'Thailand' }}>
                    {(states) => {
                      const statesByCountry = _get(states, 'data.statesByCountry')
                      const loading = _get(states, 'loading')
                      if (loading) return <Loading />
                      if (!statesByCountry) return <Error404 />
                      return <Form.Item
                        label={{ en: 'Province', th: 'จังหวัด' }[locale]}
                        {...formItemLayout}
                      >
                        {getFieldDecorator(`deliveryAddress.province`, {
                          initialValue: _get(registration, 'deliveryAddress.province'),
                          rules: [{ required: true,
                            message: requiredFieldMessage }]
                        })(
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .startsWith(input.toLowerCase())}
                            style={{ width: 213 }}
                          >
                            {statesByCountry.map(state =>
                              <Select.Option
                                key={state._id}
                                value={state._id}
                              >
                                {state.name[locale]}
                              </Select.Option>
                            )}
                          </Select>
                        )}
                      </Form.Item>
                    }}
                  </Query> */}
                  

                  <Form.Item
                    label={{ en: 'Postal Code', th: 'รหัสไปรษณีย์' }[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.postalCode`, {
                      initialValue: _get(registration, 'deliveryAddress.postalCode'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(
                      isThailand ?
                        <InputThaiAddress
                          field={"zipcode"}
                          value={postalCode}
                          onChange={this.onChange("postalCode")}
                          onSelect={this.onSelect}
                        /> :
                        <Input />
                    )}
                  </Form.Item>

                  <Form.Item
                    label={{ en: 'Fullname', th: 'ชื่อ - สกุล' }[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.fullname`, {
                      initialValue: _get(registration, 'deliveryAddress.fullname'),
                      rules: [{ required: true,
                        message: requiredFieldMessage }]
                    })(<Input key={`fullname`} />)}
                  </Form.Item>

                  <Form.Item
                    label={{ en: 'Telephone', th: 'โทรศัพท์' }[locale]}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(`deliveryAddress.telephone`, {
                      initialValue: _get(registration, 'deliveryAddress.telephone'),
                      rules: [
                        {
                          // pattern: /^[+][0-9]+?$|^[0-9]+?$/,
                          pattern: /^[0-9]{10,14}$/,
                          required: true,
                          message: 'Please enter valid telephone number'
                        }
                      ]
                    })(<Input key={`telephone`} />)}
                  </Form.Item>
                </Input.Group>:''}
                <Form.Item
                  wrapperCol={{xs: { span: 24 }, sm: { span: 16, offset: 8 }}}
                >
                  <Button className="btn" type="primary" htmlType="submit" loading={this.submitting} icon="save">{t("utils.save")}</Button>
                  <Link to={`/events/${eventId}/registrations/${registration._id}`}>
                    <Button className="btn" loading={this.submitting}>{t("utils.cancel")}</Button>
                  </Link>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Layout.Content>
      </Layout>
    )
  }
}
export default withTranslation() (RegistrationEdit)
